/**
 * Trust Bar Functionality
 * - Mobile: Rotates trust bar slides every 3 seconds
 * - Desktop: Repositions trust bar after announcement on homepage/collection
 */
(function() {
  'use strict';

  // Mobile slider
  if (window.innerWidth < 750) {
    const slides = document.querySelectorAll('#trust-bar .trust-slide');
    if (slides.length > 1) {
      let current = 0;
      setInterval(function() {
        slides[current].classList.remove('active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('active');
      }, 3000);
    }
  }

  // Desktop: Move trust bar after announcement on homepage only
  if (window.innerWidth >= 750) {
    const isHomepage = document.body.classList.contains('template-index');

    if (isHomepage) {
      const trustBar = document.getElementById('trust-bar');
      const announcement = document.querySelector('[data-section-type="announcement"]');

      if (trustBar && announcement) {
        announcement.parentNode.insertBefore(trustBar, announcement.nextSibling);
      }
    }
  }
})();
